import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Typography,
  Tabs,
  Tab,
  CircularProgress,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import UploadIcon from "@mui/icons-material/Upload";
// import CircularProgress from "@mui/icons-material/CircularProgress"
import AreasOfWorkSection from "../sections/AreasOfWorkSection";
import { toast } from "react-toastify";
import useApi from "../../api/useApi";
import { CategoryGet } from "../../api/orgService";
import { useLocation } from "react-router";
import WhatWeDo from "../pages/WhatWeDo";


export default function AddSubcategoryForm({ onAddSubcategory }) {

  const subCATEGORY_FORM_STORAGE_KEY = 'subcategoryFormState';

  const location = useLocation
  const [open, setOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [FileUpload,setConstFileUpload]=useState(false)

  const [subcategory, setsubCategory] = useState({
    name: "",
    category:"",
    subcategory_alias: "",
    description: "",
    link:"",
    image_introduction:"",
    released:false
  });

  const [tabPreviewCreate, setTabPreviewCreate] = useState(0); // 0 = New, 1 = Preview
  const [tabIndex, setTabIndex] = useState(0); // 0 = Link, 1 = Upload
  const fileInputRef = useRef(null);

    // create of work categories
    
      const { request: createSubCategory, data:createSubCategoryData, error:createSubCategoryError} = useApi(onAddSubcategory);
                
          useEffect(()=>{
            if (createSubCategoryData?.status===201) {
              toast.success(`${JSON.stringify(createSubCategoryData?.data,null,2)}`,{position: "top-center"});
              setOpen(false);
              window.localStorage.removeItem(subCATEGORY_FORM_STORAGE_KEY);
              setsubCategory({
                name: "",
                subcategory_alias: "",
                category:"",
                description: "",
                link:"",
                image_introduction:"",
                released:false
              })
              // setAreas(createSubCategoryData?.data);
            }
          // eslint-disable-next-line
          },[createSubCategoryData])
      
          // useEffect(()=>{
          //     if(location?.state?.refresh==="category"){
          //       createCategory();
          //     }
          //   // eslint-disable-next-line
          // },[location?.state])
        
          useEffect(()=>{
              if(createSubCategoryError){
                  toast.error(`${JSON.stringify(createSubCategoryError?.response?.data,null,2)}`,{position: "top-center"});
            }
          },[createSubCategoryError])
      // End create area of work categories


      // get area of work categories
      
        const { request: getAllCategories, data:categoryData, error:categoryError,loading:categoryLoading} = useApi(CategoryGet);
          
          useEffect(() => {
            getAllCategories();
                 // eslint-disable-next-line
            }, []);
            
            useEffect(()=>{
              if (categoryData?.status===200) {
                setCategories(categoryData?.data?.results);
              }
            // eslint-disable-next-line
            },[categoryData])
        
            useEffect(()=>{
                if(location?.state?.refresh==="category"){
                  getAllCategories();
                }
              // eslint-disable-next-line
            },[location?.state])
          
            useEffect(()=>{
                if(categoryError){
                    toast.error(`${JSON.stringify(categoryError?.response?.data,null,2)}`,{position: "top-center"});
              }
            },[categoryError])
        // End get area of work categories

  const generateAlias= (e) => {
    const name = subcategory?.name.trim();
    const alias = name
      .toLowerCase()         // make all lowercase
      .replace(/\s+/g, '-'); // replace spaces with hyphens
    // document.getElementById('subcategoryAlias').value = alias;
    return alias
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setsubCategory((prev) => ({ ...prev, [name]: value }));
    

    window.localStorage.setItem(subCATEGORY_FORM_STORAGE_KEY, JSON.stringify(subcategory));
  };

  const handleCategoryChange = (e) =>{
    const { name, value } = e.target;
    console.log(value)
    setsubCategory((prev) => ({ ...prev, [name]: value }));
  }

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      // Convert to local preview URL
      const previewUrl = URL.createObjectURL(file);
      setsubCategory((prev) => ({ ...prev, value: previewUrl }));
      const formData = new FormData();
      formData.append("image", file);
      setConstFileUpload(true)
      try{
        // const res = await fetch("https://178.128.35.136/cms/ftp-files/", {
          const res = await fetch("/cms/ftp-files/", {
          method: "POST",
          body: formData, // don't add headers here
        });
      // console.log(res)
      if(res?.status===201){
        let result = await res.json()
        // console.log("Upload urls: ",result)
        setsubCategory((prevData)=>({
          ...prevData,
          image_introduction: result?.path,
        }));
      // setMaterialUrl(event,event.target.value)
        // setUploadUrls(prev=>res?.data)
        setConstFileUpload(false)
      }else{
        console.log(res)
        setConstFileUpload(false)
      }
      }catch(error){
        console.log(error)
      }
    }
  };


  const handleSubmit = () => {
    if (!subcategory.name) return alert("Please provide a value.");
    // setsubCategory({ type: "text", heading: "", value: "" });
    createSubCategory(subcategory)
    
  };

  useEffect(() => {
    const saved = window.localStorage.getItem(subCATEGORY_FORM_STORAGE_KEY);
    if (saved) {
      try {
        const obj = JSON.parse(saved);
        // if (obj.name) setName(obj.name);
        // if (obj.alias) setAlias(obj.alias);
        setsubCategory(obj);
      } catch (err) {
        console.error('Could not parse saved subcategory form state', err);
      }
    }
  }, []);

  useEffect(() => {
    const saved = window.localStorage.getItem(subCATEGORY_FORM_STORAGE_KEY);
    if (subcategory?.name?.length>0) {
      setsubCategory((prev) => ({ ...prev, subcategory_alias: generateAlias() }));
      setsubCategory((prev) => ({ ...prev, link: `/what-we-do/${subcategory?.subcategory_alias}` }));
    window.localStorage.setItem(subCATEGORY_FORM_STORAGE_KEY, JSON.stringify(subcategory));
    }
  }, [subcategory?.name,subcategory?.subcategory_alias]);



  // window.localStorage.removeItem(subCATEGORY_FORM_STORAGE_KEY);

  return (<>
      {/* Add subcategory Button */}
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => setOpen(true)}
        sx={{ mb: 2 }}
      >
        Add SubsubCategory
      </Button>

      {/* Popup Form */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Add Working Area Sub subCategory</DialogTitle>
        <DialogContent>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
            <Typography
            sx={{
                mb:5,
            }}
            >Add a new activity sub subcategory (what we do subcategory) that represents the areas your organization works in — such as New Born Health in Health, Disability Education in Education, Environment, or Media. These sub categories help group and organize your organization’s projects and initiatives for each area.
            </Typography>

            <>
            <Tabs
              value={tabPreviewCreate}
              onChange={(e, newValue) => setTabPreviewCreate(newValue)}
              centered
              sx={{ mb: 1 }}
            >
              <Tab label="New SubCategory" />
              <Tab label="Preview" />
            </Tabs>
            {tabPreviewCreate === 0 ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>

            
            {/* subCategory Name */}
            <TextField
              name="name"
              label="subCategory Name"
              value={subcategory.name}
              onChange={handleChange}
              fullWidth
            >
            </TextField>

            {/* Category */}
            <TextField
            select
            name ="category"
            fullWidth
            size="small"
            label="Select Category"
            value={subcategory?.category}
            onChange={handleCategoryChange}
            variant="outlined"
            helperText="Choose a category for this record"
            disabled={categoryLoading}
            >
            {categoryLoading ? (
                <MenuItem disabled>
                <CircularProgress size={20} />
                &nbsp; Loading...
                </MenuItem>
            ) : categories.length > 0 ? (
                categories.map((cat) => (
                <MenuItem key={cat.id} value={cat.id}>
                    {cat.name}
                </MenuItem>
                ))
            ) : (
                <MenuItem disabled>No categories available</MenuItem>
            )}
            </TextField>

            <TextField
              name="name"
              label="subCategory Alias"
              placeholder="Generated alias"
              value={subcategory?.subcategory_alias}

              onChange={handleChange}
              fullWidth
            ></TextField>
            

            {/* subCategory Description */}
            <TextField
              name="description"
              label="Description (optional)"
              value={subcategory.description}
              onChange={handleChange}
              fullWidth
              multiline
              minRows={4}
            />

            {/* subCategory Image Introduction */}
            <>
              <Tabs
                value={tabIndex}
                onChange={(e, newValue) => setTabIndex(newValue)}
                centered
                sx={{ mb: 1 }}
              >
                <Tab label="subCategory Image Introduction Link" />
                <Tab label="Upload subCategory Image Introduction" />
              </Tabs>

              {tabIndex === 0 ? (
                <TextField
                  name="image_introduction"
                  label="image Link"
                  value={subcategory.image_introduction}
                  onChange={handleChange}
                  fullWidth
                />
              ) : (
                <Box
                  sx={{
                    border: "2px dashed #ccc",
                    borderRadius: 2,
                    p: 3,
                    textAlign: "center",
                  }}
                >
                  {subcategory?.image_introduction ? (
                    subcategory?.image_introduction?.length >= 0 ? (
                      <img
                        src={subcategory.image_introduction}
                        alt="preview"
                        style={{
                          width: "100%",
                          borderRadius: "8px",
                          marginBottom: "8px",
                        }}
                      />
                    ) : (
                      <Typography variant="body2" sx={{ mb: 1 }}>
                        File selected: {subcategory?.image_introduction.split("/").pop()}
                      </Typography>
                    )
                  ) : (
                    <UploadIcon sx={{ fontSize: 50, color: "#aaa", mb: 1 }} />
                  )}

                  <Button
                    variant="outlined"
                    onClick={() => fileInputRef.current.click()}
                    loading = {FileUpload}
                  >
                    {subcategory.image_introduction ? "Click To Change File" : "Click ToUpload File"}
                  </Button>
                  <input
                    type="file"
                    accept={"image/*"}
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                </Box>
              )}
            </>
            </Box>
            ):
            tabPreviewCreate===1?(
              // <AreasOfWorkSection singleView={[subcategory,]} />
              <WhatWeDo/>
            )
            :""} 
        </>
        </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
